
namespace RioERP.Carts {
    export class CounterCartColumns {
        static columnsKey = 'Carts.CounterCart';
    }
}